import {message} from "antd";
import axios from "axios";

export const formatTimestamp = (timestamp) => {
    if (!timestamp) return '-';
    const date = new Date(timestamp * 1000); // 将秒级时间戳转换为毫秒级
    return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // 24小时制
    }).replace(/\//g, '-'); // 将日期中的 / 替换为 -
};

export const formattedAddress =(text) => {
    return text.length > 10
        ? `${text.slice(0, 5)}...${text.slice(-5)}`
        : text; // 地址过短时，不做省略
}

export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
        message.success('地址已复制到剪贴板');
    }).catch(() => {
        message.error('复制失败');
    });
};

// export const tokenOptions = {
//     BSC: [
//         { name: 'BNB', address: '0x3e14602186dd9de538f729547b3918d24c823546' },
//         { name: 'WBNB', address: '0xBB4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c' },
//         { name: 'USDT', address: '0x55d398326f99059fF775485246999027B3197955' },
//         { name: 'USDC', address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d' },
//     ],
//     BASE: [
//         { name: 'ETH', address: '0x49048044D57e1C92A77f79988d21Fa8fAF74E97e' }, // 替换为实际地址
//         { name: 'WETH', address: '0x4200000000000000000000000000000000000006' }, // 替换为实际地址
//         { name: 'USDT', address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2' }, // 替换为实际地址
//         { name: 'USDC', address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913' }, // 替换为实际地址
//     ],
// };


const API_URL = '/api/v1/chain/list';

export const fetchTokenOptions = async () => {
    try {
        const response = await axios.get(API_URL);
        if (response.data.code !== 0) {
            console.error('获取链数据失败:', response.data.msg);
            return {};
        }

        const chainsData = response.data.data;
        const formattedData = {};

        // 解析返回的数据
        Object.values(chainsData).forEach(chain => {
            const { chain_name, common_address_map } = chain;

            if (chain_name && common_address_map) {
                formattedData[chain_name] = Object.entries(common_address_map).map(([name, address]) => ({
                    name,
                    address,
                }));
            }
        });

        return formattedData;
    } catch (error) {
        console.error('获取 tokenOptions 失败:', error);
        return {};
    }
};
